import { useState, useEffect, useRef, memo } from "react"

const CallDuration = memo(({ activeCall, children }) => {
  const [duration, setDuration] = useState(0)
  const timerRef = useRef(null)
  const startTimeRef = useRef(null)

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  useEffect(() => {
    if (activeCall?.callStatus === "ACCEPTED") {
      startTimeRef.current = Date.now()
      setDuration(0)
      
      timerRef.current = setInterval(() => {
        if (startTimeRef.current) {
          const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000)
          setDuration(elapsed)
        }
      }, 1000)
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
      if (!activeCall) {
        setDuration(0)
        startTimeRef.current = null
      }
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [activeCall?.callStatus, activeCall])

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [])

  if (activeCall?.callStatus !== "ACCEPTED") {
    return null
  }

  return children({ duration, formatDuration })
})

CallDuration.displayName = 'CallDuration'

export default CallDuration